<div class="seperator"></div>
<div class="title" mat-dialog-title>Add Username & Password</div>
<div class="dialog-body">
    <div class="body-content">
        <div class="form-text">You will need to contact your Outbrain support to obtain the details below</div>
        <form [formGroup]="connectionForm">
            <mat-form-field appearance="outline" class="form-field">
                <mat-label>Username</mat-label>
                <input matInput placeholder="Enter Outbrain Username" formControlName="clientId" data-cy="outbrain-username-input">
                <mat-error
                    *ngIf="connectionForm.get('clientId').errors && (connectionForm.get('clientId').touched || connectionForm.get('clientId').dirty)">
                    Invalid Username</mat-error>
                </mat-form-field>
                <mat-form-field appearance="outline" class="form-field">
                    <mat-label>Password</mat-label>
                <input type="password" matInput placeholder="Enter Outbrain Password" formControlName="clientSecret" data-cy="outbrain-password-input">
                <mat-error
                    *ngIf="connectionForm.get('clientSecret').errors && (connectionForm.get('clientSecret').touched || connectionForm.get('clientSecret').dirty)">
                    Invalid Password</mat-error>
                </mat-form-field>
        </form>
    </div>
</div>
<div class="dialog-footer">
    <div>
        <button mat-raised-button class="rubii-btn add-btn" color="primary" (click)="connect()" data-cy="outbrain-dialog-connect-btn">
            Connect Data Source
        </button>
    </div>
</div>